/**
 * InfinitSales - Contato empresarial (arquitetura empresarial, fase 3).
 *
 * GET /api/company-contacts/{id}: um documento com etapa por funil,
 * responsavel, tags, campos, comentarios, origem e identidades por canal.
 * POST /api/company-contacts/by-keys: {chave: company_contact_id} em lote.
 * O backend responde 404 com a flag desligada; quem chama segue pelas
 * chamadas de hoje. A chave opaca viaja intacta (nunca vira telefone).
 */
import api from './api';

const companyContactService = {
  async get(companyContactId) {
    if (!companyContactId) return null;
    const res = await api.get(`/api/company-contacts/${encodeURIComponent(companyContactId)}`);
    return res.data?.data || null;
  },

  async idsByKeys(keys, channel = null) {
    const lista = Array.from(new Set((keys || []).filter(Boolean)));
    const out = {};
    for (let i = 0; i < lista.length; i += 200) {
      const res = await api.post('/api/company-contacts/by-keys', {
        keys: lista.slice(i, i + 200),
        channel,
      });
      Object.assign(out, res.data?.data || {});
    }
    return out;
  },
};

export default companyContactService;
